import Config from '@config';
import { initializeNodeSealTypesApi } from '@gasbi/shared/common/features/nodeSealTypes';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const { nodeSealTypesApi, useGetNodeSealTypesQuery } =
  initializeNodeSealTypesApi(Config.VITE_API_CLIENT_URL, axiosBaseQuery);
